import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSearchParams, useSubmit } from 'react-router-dom'
import useUpdateMode from '../../hooks/useUpdateMode'
import { saveAnswer } from '../../utils/onboardingStorage'

const QUESTION_KEY = 'commit_training'

export default function CommitTrainingPage() {
  const submit = useSubmit()
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue =
    value === 'beginner' ||
    value === 'novice' ||
    value === 'intermediate' ||
    value === 'advanced'
      ? value
      : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()
  useEffect(() => {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({ type: 'REQUEST_ATT' }),
      )
    }
  }, [])
  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const sex = formData.get('answer') as string

    const answer = {
      question_key: QUESTION_KEY,
      question: 'How would you describe your current running experience?',
      answer_key: sex.toLowerCase(),
      answer: sex,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(formData, { method: 'post' })
    }
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.commitTraining.heading')}
      buttons={[
        {
          text: t('pages.onboarding.commitTraining.options.oneToTwo'),
          value: '2',
        },
        {
          text: t('pages.onboarding.commitTraining.options.threeToFour'),
          value: '4',
        },
        {
          text: t('pages.onboarding.commitTraining.options.fiveToSix.title'),
          value: '6',
          subtext: t(
            'pages.onboarding.commitTraining.options.fiveToSix.subtext',
          ),
        },
        {
          text: t('pages.onboarding.commitTraining.options.everyDay'),
          value: '7',
        },
      ]}
      onSubmit={onSubmit}
      headingSize="text-3xl"
      buttonTextSize="text-base"
      buttonBgColor="bg-white"
      preselectedValue={preselectedValue}
    />
  )
}
